var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconChevron(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10 7"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "icon-chevron_svg__st0",
    d: "M5 6.3c-.2 0-.4-.1-.5-.3l-4-4c-.3-.3-.3-.7 0-1s.8-.3 1.1 0L5 4.4 8.5 1c.3-.3.8-.3 1.1 0s.3.8 0 1.1l-4 4c-.2.1-.4.2-.6.2z"
  })));
}
export default SvgIconChevron;